module.exports = __webpack_public_path__ + "img/to_rechargepray_tc.9af084e8.png";